import React from 'react';


export default function ContactMe() {

  return (
    <div className="contact-details">
      <p > Name: Rishabh Goel</p>
      <p > Email: rishabhg0707@gmail.com</p>
      <p> Phone: +44 744 3888 379</p>
    </div>
  );


}

